import { D3Selection } from "svg/draw/draw-calendar";
import { CalendarSizeDimensions } from "svg/constants";
import { SpiralItem } from "burde";

const drawDualPageSpiral = (
    svg: D3Selection,
    spiral: SpiralItem | null,
    numberOfSpirals: number,
    calendarDimensions: CalendarSizeDimensions,
) => {
    const spiralHeightGap: number =
        (calendarDimensions.contentHeightWithoutBleeds -
            numberOfSpirals * calendarDimensions.spiralHeight) /
        (numberOfSpirals + 1);

    var spiralStartPos: number =
        calendarDimensions.presentationEmptySpaceHeight;

    const spiralImage = (spiral as SpiralItem).image.replace("#", "double");

    var spiralStartPos: number =
        calendarDimensions.presentationEmptySpaceHeight;
    for (let i = 0; i < numberOfSpirals; i++) {
        svg.append("svg:image")
            .attr(
                "x",
                calendarDimensions.contentWidthWithoutBleeds +
                    calendarDimensions.presentationEmptySpaceWidth +
                    calendarDimensions.pageGap / 2 -
                    calendarDimensions.spiralWidth / 2,
            )
            .attr("y", spiralStartPos + spiralHeightGap)
            .attr("width", calendarDimensions.spiralWidth)
            .attr("height", calendarDimensions.spiralHeight)
            .attr("xlink:href", `/images/${spiralImage}`);

        spiralStartPos += calendarDimensions.spiralHeight + spiralHeightGap;
    }
};

export { drawDualPageSpiral };
